import { Navigate, useParams } from "react-router"
import { LocationDetails } from "../components/LocationDetails/LocationDetails"
import { useGetAsset } from "../components/WatchedLocations/hooks/useAssetService"
import { ROUTES } from "../utils/constants"
import { getAssetName, getLocationId } from "../utils/helpers"

export const Asset: React.FC = () => {
  const { asset_id } = useParams<{ asset_id: string }>()
  const { data, isLoading } = useGetAsset(asset_id)
  const { title, subtitle } = getAssetName(data?.asset)

  if (!asset_id) {
    console.error("Invalid parameters", { asset_id })
    return <Navigate to={ROUTES.NOT_FOUND} />
  }

  const location_id = getLocationId(data?.asset)

  if (isLoading || !location_id || !data?.asset) {
    return null
  }

  return (
    <LocationDetails
      location_id={location_id}
      title={title || ""}
      subtitle={subtitle}
    />
  )
}
